import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Mandate from "@/pages/Mandate";
import Legal from "@/pages/Legal";
import StaffLogin from "@/pages/StaffLogin";
import StudioLayout from "@/pages/studio/StudioLayout";
import Dashboard from "@/pages/studio/Dashboard";
import PraticaDetail from "@/pages/studio/PraticaDetail";
import ConsapImport from "@/pages/studio/ConsapImport";
import Searches from "@/pages/studio/Searches";
import Users from "@/pages/studio/Users";
import Settings from "@/pages/studio/Settings";
import AuditLog from "@/pages/studio/AuditLog";
import { CookieBanner } from "@/components/landing/CookieBanner";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/studio/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/mandato/:token" element={<Mandate />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/cookie" element={<Legal kind="cookie" />} />
            <Route path="/studio/login" element={<StaffLogin />} />
            <Route path="/studio" element={<Protected><StudioLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="pratiche/:id" element={<PraticaDetail />} />
              <Route path="consap" element={<ConsapImport />} />
              <Route path="ricerche" element={<Searches />} />
              <Route path="utenti" element={<Users />} />
              <Route path="impostazioni" element={<Settings />} />
              <Route path="audit" element={<AuditLog />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
          <WhatsAppButton />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
